import adminImg from '../../../../../assests/messages/adminImg.png'
import { messageOwnerType } from '../../../../enums/messageOwnerType'
import UserInitials from '../../../ui/userInitials/UserInitials'
import classes from '../Message.module.css'

const MessageSenderAvatar = ({ ownerTypeId, metadata }) => {

    const { firstName = '', lastName = '' } = metadata ?? {}
    const hasMetadata = Boolean(firstName.trim() || lastName.trim())

    return (
        <>
            {ownerTypeId === messageOwnerType.admin && 
                <>
                    <img src={adminImg} alt="משרד החינוך" className={classes.AdminAvatar} />
                    <p className={classes.SenderAvatarName}>משרד החינוך</p>
                </>
           }
            {ownerTypeId === messageOwnerType.teacher && hasMetadata && 
                <UserInitials firstName={firstName} lastName={lastName} />
            }
            {ownerTypeId === messageOwnerType.teacher && !hasMetadata && 
                <img src={`${window.config.bucketFilesUrl}/messages/teacherImg.png`} alt="מורה" className={classes.AdminAvatar} />
            }
        </>
    )

}

export default MessageSenderAvatar
